import { useLocation } from "react-router-dom";
import ForbiddenAccess from "src/Pages/ForbiddenAccess";
import { isCustomerUser } from "src/helper";

const CUSTOMER_ALLOWED_PATH = "/iMEPortfolio";

interface ICustomerRouteGuard {
  children: React.ReactNode;
}

const CustomerRouteGuard = ({ children }: ICustomerRouteGuard) => {
  const location = useLocation();

  if (!isCustomerUser()) return <>{children}</>;
  if (location.pathname === CUSTOMER_ALLOWED_PATH) return <>{children}</>;

  return <ForbiddenAccess />;
};

export default CustomerRouteGuard;
